import { ExtendedListing } from '../../../../../../../../models/Listing';
import { ShareStep } from '../../../ShareDialog';
import ShareOptions from '../../ShareOptions/ShareOptions';
import VehicleInformation from '../../VehicleInformation/VehicleInformation';
import { Container } from './InitialStep.styles';

interface InitialStepProps {
  listing: ExtendedListing;
  setStep: (step: ShareStep) => void;
}

const InitialStep = ({ listing, setStep }: InitialStepProps) => (
  <Container>
    <VehicleInformation listing={listing} isInitialStep />
    <ShareOptions listingId={listing?.listingId} setStep={setStep} />
  </Container>
);

export default InitialStep;
